// Decorative party popper: the confetti colours are the same in both themes.
const COLORS = {
  cone: '#f98143', // theme-ok: decorative illustration
  stripes: '#ffdc6e', // theme-ok: decorative illustration
  rim: '#d95d2e', // theme-ok: decorative illustration
  purple: '#a36cc3', // theme-ok: decorative illustration
  pink: '#ea6387', // theme-ok: decorative illustration
  green: '#53c496', // theme-ok: decorative illustration
}

export function Party() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 64 64"
      id="party-popper"
    >
      <path
        fill={COLORS.cone}
        d="M6.36953,63.33142l36.68933-14.70856L15.05339,20.61738L0.34483,57.30671
			C-1.17226,61.09096,2.58528,64.8485,6.36953,63.33142z"
      ></path>
      <path
        fill={COLORS.stripes}
        d="M20.28823 57.74817l-9.75865 3.91451c-.99926-.55827-1.98481-1.14404-2.95656-1.75741-2.23286-1.41969-4.37616-2.97032-6.40922-4.64499l3.05991-7.636c2.33625 2.10196 4.85863 4.00407 7.51877 5.68564C14.47855 55.03974 17.32478 56.52143 20.28823 57.74817zM39.90884 49.88473l-11.40573 4.56923c-3.56299-1.44038-6.99508-3.19085-10.26863-5.26526-4.00407-2.54303-7.71865-5.51335-11.08184-8.86274l3.19775-7.98054c3.52168 3.97647 7.57396 7.42236 12.05355 10.24793C27.80014 46.00475 33.68563 48.45819 39.90884 49.88473z"
      ></path>
      <path
        d="M43.06457,48.62342L6.36524,63.3251c-3.78516,1.51774-7.53382-2.2308-6.01607-6.01596l1.62746-4.05949
			c5.19319,1.07891,11.99542,1.28002,18.96228-1.91998c7.03996-3.2183,11.09944-8.46629,13.12913-11.7029L43.06457,48.62342z"
        opacity=".1"
      ></path>
      <ellipse
        cx="29.056"
        cy="34.62"
        fill={COLORS.rim}
        rx="5.9"
        ry="19.803"
        transform="rotate(-45 29.056 34.62)"
      ></ellipse>
      <path
        fill={COLORS.purple}
        d="M38.20045,42.94522l-1.37866-1.00535c-0.70648-0.51518-0.86156-1.50552-0.34638-2.212l0.50268-0.68933
			c1.50751-2.06761,3.87184-3.53449,6.65765-4.13089c3.21564-0.68827,5.55701-0.02209,8.266,0.75153l0.93583,0.26474
			c1.97578,0.55308,4.60412,1.01711,7.42042-0.28972l0.77476-0.35921c0.7933-0.36781,1.73457-0.02283,2.10231,0.7705
			l0.71775,1.54844c0.36774,0.79333,0.02268,1.73457-0.77069,2.10224l-0.77367,0.35854
			c-4.31158,1.99802-8.21683,1.27864-10.78067,0.563l-0.9623-0.27208c-2.502-0.71407-3.88104-1.10912-5.90967-0.67241
			c-1.61211,0.3445-2.94055,1.13895-3.74068,2.23632l-0.50267,0.68933C39.89728,43.30532,38.90693,43.4604,38.20045,42.94522z"
      ></path>
      <path
        fill={COLORS.pink}
        d="M25.37624,27.45421l-1.20325-1.21063c-0.61638-0.62016-0.61332-1.62257,0.00684-2.23895l0.60531-0.60163
			c1.29778-1.28973,1.83985-1.87908,2.22588-3.52922c0.35949-1.53934,0.30132-3.0914,0.2453-4.59234
			c-0.03916-1.05938-0.08026-2.15643,0.02677-3.23371c0.21824-2.18761,0.72748-7.30963,6.48734-10.78164l0.73037-0.44064
			c0.74881-0.45177,1.72208-0.21082,2.17365,0.53812l0.88096,1.46112c0.45156,0.74894,0.21034,1.72214-0.53872,2.1735
			l-0.73075,0.44032c-3.38503,2.04174-3.90743,4.62248-4.15372,7.09148c-0.07369,0.74667-0.04128,1.6325-0.00589,2.57052
			c0.06442,1.73707,0.13784,3.70554-0.37068,5.88221c-0.66767,2.85588-1.88594,4.23726-3.53514,5.8767l-0.60531,0.60163
			C26.99503,28.07743,25.99262,28.07437,25.37624,27.45421z"
      ></path>
      <path
        fill={COLORS.green}
        d="M57.41374,10.14166l1.63054,0.50408c0.83529,0.25823,1.30313,1.14466,1.045,1.97998l-0.25176,0.81471
			c-1.40625,4.55132-3.47828,7.81205-6.33371,9.96937c-3.0179,2.27946-5.28926,2.83847-7.91957,3.48645
			c-0.73678,0.181-1.53369,0.377-2.42632,0.63112c-2.20996,0.62973-5.31815,2.15845-7.57161,5.86473l-0.44382,0.72919
			c-0.45451,0.74675-1.42825,0.98379-2.17513,0.52949l-1.45884-0.88736c-0.74688-0.4543-0.98418-1.42799-0.53008-2.17499
			l0.44355-0.72964c3.07458-5.05358,7.35335-7.14944,10.40156-8.01767c0.95448-0.27209,1.80677-0.48282,2.59525-0.67642
			c2.45081-0.60397,3.92995-0.9682,6.14751-2.64338c2.01134-1.51897,3.52066-3.97879,4.61502-7.51906l0.25231-0.81583
			C55.69196,10.35118,56.57845,9.88343,57.41374,10.14166z"
      ></path>
      <circle cx="18.318" cy="6.054" r="2.553" fill={COLORS.purple}></circle>
      <circle cx="49.053" cy="3.501" r="3.177" fill={COLORS.green}></circle>
      <circle cx="55.505" cy="48.366" r="2.832" fill={COLORS.pink}></circle>
    </svg>
  )
}
